import React, {Component} from 'react';

import axios from 'axios';
import { withRouter } from "react-router-dom";
//import ReactImageMagnify from 'react-image-magnify';
import { Alert } from 'reactstrap';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import "react-toggle-component/styles.css"

import DatePicker from "react-datepicker";
import {SERVER_URL}  from '../Constants';
import "react-datepicker/dist/react-datepicker.css";


const colors = ['','Clear','Beige', 'Black','Blue','Brown','Camo','Gold','Green','Grey','Orange','Pink', 'Purple', 'Red', 'Silver','Turquoise','White','Yellow', 'Violet'];



class QuickClaim extends Component {
  constructor(props) {
    super(props);

    
    //const { match: { params } } = this.props;

    var lostItemId = (this.props.match.params.lostItemId) ? this.props.match.params.lostItemId: this.props.lostItemId
    this.state = {
      claim:null,
      lostItem: null,
      venueId:auth0Client.getActiveVenuedId(),
      claimId: undefined,
      updatedDate:'',
      claimDate:new Date(),
      //lostItemId: (this.props.match.params.lostItemId) ? this.props.match.params.lostItemId : '',
      lostItemId: (lostItemId) ? lostItemId : '',
      status: 'O',
      firstName: '',
      lastName: '',
      phone:'',
      email:'',
      details:'',
      claimSource:'INTERNAL',
      pickupDate:'',
      shipDate:'',
      disabled :false,
      showSuccess: false,
      showLostItemPicker: false,
      shippingAddress:'',
      shippingAddress2:'',
      shippingCity:'',
      shippingPostalCode:'',
      shippingState:'',
      shippingCountry:'US',
      locationLost:'',
      showOpenShipment:false,
      disableRequestShippingLabel : (this.props.lostItemId) ? false : true,
      showNewReturn: false,
      claimNotificationButtonTitle: 'Send Claim Notification',
      isVIP: false,
      category:'',
      subcat:undefined,
      brand:'',
      color:'',
      filterdSubItems: [{"name": "NA"}],
      section:'',
      row:'',
      parkingLot:'',
      venueTypeCd:'',
      airportCd:'',
      seat:'',
      flightNumber: '',
      terminal:'',
      gate:'',
      notifyBySms:true,
      travelDate: new Date(),
      categoriesMap:[]
    };




  }




  

  async componentDidMount() {
    //const { match: { params } } = this.props;
    var venue = auth0Client.getDefaultVenue();
    if (venue){
      this.setState({
        venueTypeCd:auth0Client.getDefaultVenue().venueTypeCd
  
      })     
      
    }else{
      ToastStore.error("An error occured: Login required.  Please log it");
    }
    this.loadReportCategories();
   
  }

  formatDate=(dateString)=>{
    var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(dateString).toLocaleDateString([],options);
  }
  

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  loadReportCategories = ()=>{
    try {
      axios.get(`${SERVER_URL}/Reports/reportCategories`,{
         headers: { 
           'Authorization': `Bearer ${auth0Client.getIdToken()}`,
           'venueId' : auth0Client.getActiveVenuedId()
         }
        
        }).then((res)=>{
         
         if (res.status===undefined || res.status !==200) {
           //place your reentry code
           console.log("Error" + res.status);
           ToastStore.error("An error occured. Please try again");
          }
 
         const categoriesMap = res.data.categoriesMap;
         this.setState({
              categoriesMap : categoriesMap,
          
          });


        },
        (error)=>{
          if (error.response && error.response.status === 401){
            ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
          }else {
            ToastStore.error('An error occured:' + error.message);
          }
          
        }
        );
    }catch(e){
        //console.log(e);
        ToastStore.error('An error occured:' + e.message);
    }


 }

  submit=async()=>{

    if (!await this.validate()){
      return;
    }

    this.setState({
      disabled: true,
    });
    
    await axios.post(`${SERVER_URL}/Claims/`, {
        id:(this.state.claimId==='-1') ? undefined : this.state.claimId,
        status: this.state.status,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email:this.state.email,
        address:this.state.address,
        lostItemId:this.state.lostItemId,
        phone:this.state.phone,
        details:this.state.details,
        claimDate: Date.parse(this.state.claimDate),
        claimSource : this.state.claimSource,
        pickupDate:(this.state.pickupDate) ? Date.parse(this.state.pickupDate) : undefined,
        shipDate:(this.state.shipDate) ? Date.parse(this.state.shipDate) : undefined,
        venueId: auth0Client.getActiveVenuedId(),
        shippingAddress: this.state.shippingAddress,
        shippingAddress2: this.state.shippingAddress2,
        shippingCity: this.state.shippingCity,
        shippingState: this.state.shippingState,
        shippingPostalCode: this.state.shippingPostalCode,
        shippingCountry:this.state.shippingCountry,
        locationLost:this.state.locationLost,
        isVIP:this.state.IsVIP,
        category:this.state.category,
        subcat:this.state.subcat,
        brand:this.state.brand,
        color:this.state.color,
        section:this.state.section,
        row:this.state.row,
        parkingLot:this.state.parkingLot,
        airportCd:this.state.airportCd,
        seat:this.state.seat,
        flightNumber:this.state.flightNumber,
        terminal:this.state.terminal,
        gate:this.state.gate,
        notifyBySms:true,
        travelDate: (this.state.travelDate) ? Date.parse(this.state.travelDate) : undefined,

    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
       


        this.setState({
          showAlert:false,
          disabled: false,
          showSuccess: true,

      });
       if(res.status!==200){
          // console.log(JSON.stringify(res));
           ToastStore.error("An error occured: " + res.response.data);
         }else{
           ToastStore.success('Claim Saved Successfully!');
           this.props.onClose();
         }
     
     
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        if (this.state.error && this.state.error.response){
          ToastStore.error(this.state.error.response.data);
        }
       
    })


  }


   renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}



  validate=async()=>{
    if (!this.state.firstName) {ToastStore.error('Invalid or First Name'); return false;}
    if (!this.state.lastName) {ToastStore.error('Invalid or missing Last Name'); return false;}
    if (!this.state.email && !this.state.phone) {ToastStore.error('Invalid or missing phone or email'); return false;}
    //if (!this.state.phone) {ToastStore.error('Invalid or missing phone'); return false;}
    if (!this.state.details) {ToastStore.error('Invalid or missing claim description'); return false;}

    return true;


  }


  renderAlert=()=>{
    if (this.state.showAlert){
        
        return (
            <Alert color='danger' onDismiss={this.handleDismiss}>
            <h4>Oh snap! You got an error!</h4>
            <p>{this.state.error.response.data}</p>
          </Alert>
        );
    }

}
renderSavedSuccessAlert=()=>{
  if (this.state.showAlert){
      
      return (
          <Alert color='success' onDismiss={this.handleDismiss}>
          <h4>Oh snap! You got an error!</h4>
          <p>{this.state.error.response.data}</p>
        </Alert>
      );
  }

}


onTravelDateChange = date => this.setState({ travelDate :date })

handleCatChange=(event)=>{
  const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

  
    if (value===undefined || value===''){ return ;}
    //locate the filter
    let filteredItems = this.state.categoriesMap.filter(item=>{
      if (item.name.toUpperCase() === value.toUpperCase()){
        return item;
      }else{
        return null;
      }
    });
    let subCatCopy = [];
    if (filteredItems.length >0){
      subCatCopy= filteredItems[0].subcat.map((x) => x);
    }
    
    // add a blank option
    //subCatCopy.unshift({ "name": " "});
    this.setState({
      [name]: value,
      filterdSubItems :  (filteredItems.length >0 ) ? subCatCopy : [],
    });
}

  
  renderWholeScreen=()=>{
    return (

    

      <div style={{margin:'0px'}} >
            {this.renderToast()}
             <div className="row">  
             <div className='col-12'> 
                  <div className="col-md  text-center ">
                  <h5>QUICK CLAIM</h5> <br/>  
                  </div>
                  </div>
              </div>
                <hr/>
                      <div className="form-group">
                     
                      
                        <div className='form-row'>
                            <div className='col-12  text-center '>
                              <h6 className='text-danger'> Name Fields Required (Phone or Email) </h6>
                            </div>
                        </div>

                        <div className='form-row'>
                            <div className='col-6'>
                                  <label htmlFor="firstName" className='text-primary'>First Name:</label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="firstName"
                                                className="form-control"
                                               
                                                value= {this.state.firstName}
                                              />
                            </div>
                            <div className='col-6'>
                                            <label htmlFor="lastName" className='text-primary'>Last Name :</label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="lastName"
                                                className="form-control"
                                              
                                                value= {this.state.lastName}
                                              />
                              </div>

                      </div>
                       
                        <div className='form-row'>
                          <div className='col-6'>
                                            
                                          <label htmlFor="email" className='text-primary'>Email :</label>
                                            <input
                                              disabled={this.state.disabled}
                                              type="email"
                                              onChange={this.handleInputChange}
                                              name="email"
                                              className="form-control"
                                             
                                              value= {this.state.email}
                                            />
                          </div>
                         <div className='col-6'>
                                          <label htmlFor="phone" className='text-primary'>Phone:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="phone"
                                            onChange={this.handleInputChange}
                                            name="phone"
                                            className="form-control"
                                           
                                            value= {this.state.phone}
                                          />
                           </div>
                         </div>

                         <div className="form-row">
                          <div className="col-6">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Date Lost:</label>
                  
                          <DatePicker
                              className="form-control"
                              onChange={this.onTravelDateChange}
                              name="travelDate"
                              selected={this.state.travelDate}
                            />
                          </div>
                          <div className='col-6'>
                                          <label htmlFor="locationLost" className='text-primary'>Location Lost:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="locationLost"
                                            className="form-control"
                                           
                                            value= {this.state.locationLost}
                                          />
                           </div>
                        
                  </div>
                  <div className="form-row">
                          <div className="col-12">
                                     
                                          <hr/>

                                          <label htmlFor="exampleInputEmail1" className='text-primary'>Claim Description</label>
                                          <textarea
                                            disabled={this.state.disabled}
                                            type="text"
                                            name="details"
                                            onChange={this.handleInputChange}
                                            className="form-control"
                                            placeholder="Describe the item that was lost in detail"
                                            value= {this.state.details}
                                          />
       
                       </div>
                  </div>
                  <div className="row">   
                      <div className="col-12">
                          <label htmlFor="category" className='text-primary'>Category:</label>
                          <select
                                  disabled={this.state.disabled}
                                  type="text"
                                  onChange={this.handleCatChange}
                                  name="category"
                                  className="custom-select"
                                  placeholder=""
                                  value= {this.state.category}
                                > 
                                <option key="*1" value=""></option>
                                {this.state.categoriesMap.map(item =>(
                                  <option key={item.name} value={item.name}>
                                  {item.name}
                              </option>
                                ))}
                                              
                                                                    
                                </select>   
                            </div>

                 </div>  
                 <div className="row">   
                      <div className="col-12">
                          <label htmlFor="category" className='text-primary'>Sub Category:</label>
                          <select
                                  disabled={this.state.disabled}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  name="subcat"
                                  className="custom-select"
                                  placeholder=""
                                  value= {this.state.subcat}
                                > 
                                <option key="*1" value=""></option>
                                {this.state.filterdSubItems.map(item =>(
                                  <option key={item.name} value={item.name}>
                                  {item.name}
                              </option>
                                ))}
                                              
                                                                    
                                </select>   
                            </div>

                 </div>                            
                 <div className='row'>
                 <div className="col-6">
                      <label htmlFor="color" className='text-primary'>Color:</label>
                      <select
                                                      disabled={this.state.disabled}
                                                      type="text"
                                                      onChange={this.handleInputChange}
                                                      name="color"
                                                      className="custom-select"
                                                      placeholder=""
                                                      value= {this.state.color}
                                                    > 
                                                          {colors.map(item=>(
                                                              <option value={item} key={item}>
                                                              {item}
                                                              </option>
                                                          ))}              
                                                    </select>   
                        </div>
                    <div className="col-6">
                    <label htmlFor="brand" className='text-primary'>Brand:</label>
                                                  <input
                                                    disabled={this.state.disabled}
                                                    type="text"
                                                    onChange={this.handleInputChange}
                                                    name="brand"
                                                    className="form-control"
                                                    placeholder=""
                                                    value= {this.state.brand}
                                                  />
                    </div>
       

                </div>
               <br/>                                            
                <div className="row">   
               
                 <div className="col-md-12 text-center">
                 <button
                        disabled={this.state.disabled}
                        className="btn btn-primary"
                        onClick={() => {this.submit()}}>
                        Save
                      </button>
                 </div>
                
                

                
         
                </div>
                   </div>

 </div>
        

      
        
    

  
     
     
    )
  }



render() {

  
    const {claim} = this.state;
    if (claim === null && this.props.match.params.newflag===false) {
      return (
        
      <div className="container">
       {this.renderGoBack()}
      <br/>
      <p>Loading ...</p>

      </div>
       
    )
  }else{
    return (
      <div>
     { this.renderWholeScreen()}
            
        

     </div>
    )
  }


  }
}

export default withRouter(QuickClaim);


